import { Injectable } from "@angular/core";
import { NetworkService } from "../../shared/network.service";

@Injectable({
  providedIn: "root",
})
export class OrderService {
  constructor(private networkservice: NetworkService) {}

  getPaymentApi(query: any) {
    return this.networkservice.get(
      "api/invoice?" + query,
      null,
      null,
      "bearer"
    );
  }
  getNewOrder(query: any) {
    return this.networkservice.get(
      "api/order/unassignedOrdersSound?" + query,
      null,
      null,
      "bearer"
    );
  }

  getNearByDriversApi(query: any) {
    return this.networkservice.get(
      "api/order/nearByDrivers?" + query,
      null,
      null,
      "bearer"
    );
  }
  assignDriver(body: any) {
    return this.networkservice.put(
      "api/order/acceptRejectOrder",
      body,
      null,
      "bearer"
    );
  }
  refundOderAPi(body: any) {
    return this.networkservice.post(
      "api/admin/refundOrder",
      body,
      null,
      "bearer"
    );
  }
  markAsDeliveredApi(body: any) {
    return this.networkservice.put(
      "api/order/updateOrderStatus",
      body,
      null,
      "bearer"
    );
  }
  getOrderApi(query: any) {
    return this.networkservice.get("api/order?" + query, null, null, "bearer");
  }
  updatePost(body) {
    return this.networkservice.post(
      "api/order/returnOrder",
      body,
      null,
      "bearer"
    );
  }
  getOrderList() {
    return this.networkservice.get("api/order", null, null, "bearer");
  }
  getOperatorList() {
    return this.networkservice.get("api/operator", null, null, "bearer");
  }
  createInvoice() {
    return this.networkservice.get(
      "api/invoice/generateDailyInvoice",
      null,
      null,
      "bearer"
    );
  }

  putPaymentApi(body: any) {
    return this.networkservice.put("api/payment", body, null, "bearer");
  }
  cancelOrderApi(body: any) {
    return this.networkservice.put(
      "api/order/cancelOrder",
      body,
      null,
      "bearer"
    );
  }
  cancelDriverApi(body: any) {
    return this.networkservice.put(
      "api/order/unassignedDriver",
      body,
      null,
      "bearer"
    );
  }
  getInvoiceApi(query: any) {
    return this.networkservice.get(
      "api/order/invoice?" + query,
      null,
      null,
      "bearer"
    );
  }
  getOTPPickup(query: any) {
    return this.networkservice.get(
      "api/order/returnOrder/otp?" + query,
      null,
      null,
      "bearer"
    );
  }
  getRevanue() {
    return this.networkservice.get(
      "api/dashboard/invoice",
      null,
      null,
      "bearer"
    );
  }
  getPendingInvoice() {
    return this.networkservice.get(
      "api/dashboard/pendingInvoiceList",
      null,
      null,
      "bearer"
    );
  }
}
